/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
/* eslint-disable consistent-return */
import { apiGetModel, getApi } from '../../useApiHook';
import { mapAvailableTimeSpans, mapOptions } from './mappingDtos';

export const getAvailableTimeSpansForTreatment = (auth, entityModel, forceReload, callback) => {
  // Prepare api model and request call
  const model = apiGetModel(
    'GetAvailableTimeSpansForTreatment',
    entityModel,
    forceReload,
    mapAvailableTimeSpans,
    callback,
  );
  getApi(auth, model);
};

export const getAvailableTimeSpansForTreatments = (auth, entityModel, callback) => {
  const model = apiGetModel('GetAvailableTimeSpansForTreatments', entityModel, mapAvailableTimeSpans, callback);
  getApi(auth, model);
};

export const GetAvailableTimeSpansForLunchBreak = (auth, entityModel, forceReload, callback) => {
  // Prepare api model and request call
  const model = apiGetModel(
    'GetAvailableTimeSpansForLunchBreak',
    entityModel,
    forceReload,
    mapAvailableTimeSpans,
    callback,
  );
  getApi(auth, model);
};

export const getMovedReasons = (auth, entityModel, forceReload, callback) => {
  // Prepare api model and request call
  const model = apiGetModel('GetMovedReasonsOptions', entityModel, forceReload, mapOptions, callback);
  getApi(auth, model);
};

export const getVisibleOrgUnits = (auth, entityModel, forceReload, callback) => {
  // Prepare api model and request call
  const model = apiGetModel('GetCurrentUserTeamsOptions', entityModel, forceReload, mapOptions, callback);
  getApi(auth, model);
};

export const getUnsuccessfulSyncPatientById = (auth, id, forceReload, callback) => {
  // Prepare api model and request call
  const model = apiGetModel('GetUnsuccessfulSyncPatientById', { id }, forceReload, null, callback);
  getApi(auth, model);
};

export const getPatientAuditById = (auth, id, forceReload, callback) => {
  // Prepare api model and request call
  const model = apiGetModel('GetPatientAuditById', { id }, forceReload, null, callback);
  getApi(auth, model);
};

export const getCancelledTreatmentInstances = (auth, entityModel, forceReload, callback) => {
  const model = apiGetModel('GetCancelledTreatmentInstances', entityModel, forceReload, null, callback);
  getApi(auth, model);
};

export const getOrgUnitTeams = (auth, id, forceReload, callback) => {
  // Prepare api model and request call
  const model = apiGetModel('GetOrgUnitTeamsOptions', { id }, forceReload, mapOptions, callback);
  getApi(auth, model);
};

export const getFilterOptionsByReferralId = (auth, entityModel, forceReload, callback) => {
  const model = apiGetModel('GetFilterOptionsByReferralId', entityModel, forceReload, null, callback);
  getApi(auth, model);
};
